import React from 'react';
import PropTypes from 'prop-types';
import GatsbyLink from 'gatsby-link';
import { parse } from 'url';

import Link from '@marvelapp/marvel-ui/link';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck.js';
import generalStyles from './style/general.module.css';
import routes from '../../../routes.json';

export default function SmartLink({
  children,
  url,
  openInNewTab,
  block = false,
  type,
}) {
  const target = openInNewTab === false ? '_self' : '_blank';

  return (
    <span className={generalStyles.link}>
      {isMarketingSiteLink(url) ? (
        <GatsbyLink to={url}>
          <Link type={type}>{children}</Link>
        </GatsbyLink>
      ) : (
        <Link url={url} target={target} type={type} block={block}>
          {children}
        </Link>
      )}
    </span>
  );
}

function isMarketingSiteLink(url) {
  // url does not start with '/', assume it's external
  if (!/^\//.test(url)) {
    return false;
  }

  const linkUrl = parse(url).pathname.replace(/\/$/, '');
  return routes.some(route => route === linkUrl);
}

SmartLink.propTypes = {
  children: PropTypes.node.isRequired,
  url: propTypeEmptyString,
  block: PropTypes.bool,
  openInNewTab: PropTypes.bool,
  type: PropTypes.string,
};

SmartLink.defaultProps = {
  type: 'blue',
};



// WEBPACK FOOTER //
// ./src/components/modules/SmartLink/index.js